export const WIDTH_SIDEBAR = '12rem';
export const HEIGTH_TOPBAR = '64px';
export const START_CONTENT_TOP = '5rem';